var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.832 60.1921L54.4439 47.7987C63.7133 35.4116 61.1859 17.8555 48.7987 8.58612C36.4116 -0.683254 18.8555 1.8442 9.58612 14.2313C0.316746 26.6184 2.8442 44.1746 15.2313 53.4439C25.1817 60.8899 38.8483 60.8899 48.7987 53.4439L61.1921 65.8373C62.7495 67.3947 65.2746 67.3947 66.8319 65.8373C68.3894 64.2798 68.3894 61.7547 66.8319 60.1974L66.832 60.1921ZM32.1183 51.0519C21.1092 51.0519 12.1847 42.1274 12.1847 31.1183C12.1847 20.1092 21.1092 11.1847 32.1183 11.1847C43.1274 11.1847 52.0519 20.1092 52.0519 31.1183C52.0402 42.1224 43.1225 51.0402 32.1183 51.0519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/white-search.94c114dd4e35cd66cba6346e94b4e75d.svg";
export { ForwardRef as ReactComponent };